import { isEmpty } from 'lodash';
import t from './BomLibrary.type';

const yearsList = [
  { value: '2015', label: '2015' },
  { value: '2016', label: '2016' },
  { value: '2017', label: '2017' },
  { value: '2018', label: '2018' },
  { value: '2019', label: '2019' },
  { value: '2020', label: '2020' },
  { value: '2021', label: '2021' },
  { value: '2022', label: '2022' },
];

const initlialState = {
  BOMProperty: {},
  ReferenceType: [],
  ReferenceSupplier: [],
  Composition: [],
  UnitOfMeasure: [],
  BOMLibraryList: [],
  newBomLibraryList: [],
  TotalCount: 0,
  colourDocs: [],
  userList: [],
  allCategory1: [],
  allCategory2: [],
  allCategory3: [],
  allCategory4: [],
  // BOM LIBRARY GROUP VAR
  SeasonList: [],
  YearsList: yearsList,
  CategoryOneList: [],
  CategoryTwoList: [],
  CategoryThreeList: [],
  BomLibraryGroupList: [],
  TagsInput: [],
  tagsList: [],
  tagsListById: [],
  supplierFactories: [],
  bomOptionsList: [],
  bomComponentSubTypeList: [],
  bomComponentSubTypeBomList: [],
};

const BomLibrary = (state = initlialState, action) => {
  switch (action.type) {
    case t.FETCH_BOM_LIBARARY:
      return {
        ...state,
        BOMProperty: action.payload,
      };
    case t.FETCH_USERS:
      return {
        ...state,
        userList: action.payload,
      };
    case t.FETCH_CATEGORY1:
      return {
        ...state,
        allCategory1: action.payload,
      };
    case t.FETCH_CATEGORY2:
      return {
        ...state,
        allCategory2: action.payload,
      };
    case t.FETCH_CATEGORY3:
      return {
        ...state,
        allCategory3: action.payload,
      };
    case t.FETCH_CATEGORY4:
      return {
        ...state,
        allCategory4: action.payload,
      };
    case t.FETCH_COLOUR_DOC:
      return {
        ...state,
        colourDocs: action.payload,
      };
    case t.FETCH_REFERENCE_TYPE:
      return {
        ...state,
        ReferenceType: action.payload,
      };
    case t.FETCH_REFERENCE_SUPPLIER: {
      const suppliers = [];
      if (!isEmpty(action.payload)) {
        suppliers.push(...action.payload);
      }
      return {
        ...state,
        ReferenceSupplier: suppliers,
      };
    }
    case t.FETCH_COMPOSITION:
      return {
        ...state,
        Composition: action.payload,
      };
    case t.FETCH_UNIT_OF_MEASURE:
      return {
        ...state,
        UnitOfMeasure: action.payload,
      };
    case t.EDIT_BOM_LIBARARY:
    case t.ADD_BOM_LIBARARY:
      return {
        ...state,
        BOMLibraryList: action?.payload?.doc || [],
        TotalCount: action?.payload?.totalCount || 0,
      };
    case t.GET_BOM_LIBARARY:
      return {
        ...state,
        BOMLibraryList: [...state.BOMLibraryList, ...(action?.payload?.doc || [])],
        newBomLibraryList: [...(action?.payload?.doc || [])],
        TotalCount: action?.payload?.totalCount || 0,
      };
    case t.DELETE_BOM_LIBARAY: {
      const removeList = JSON.parse(JSON.stringify(state.BOMLibraryList));
      const ids = action?.payload?.bomLibId ? action.payload.bomLibId : [];
      const removeDataById = removeList.filter((item) => ids.indexOf(item._id) === -1);
      return {
        ...state,
        BOMLibraryList: removeDataById,
      };
    }
    case t.FETCH_SEASON:
      return {
        ...state,
        SeasonList: action.payload,
      };
    case t.FETCH_CATEGORY_ONE:
      return {
        ...state,
        CategoryOneList: action.payload,
      };
    case t.FETCH_CATEGORY_TWO:
      return {
        ...state,
        CategoryTwoList: action.payload,
      };
    case t.FETCH_CATEGORY_THREE:
      return {
        ...state,
        CategoryThreeList: action.payload,
      };
    case t.GET_BOM_LIBARARY_WITHOUT_PAGINATE: {
      const newSearchList = [...action.payload.doc];
      const uniqueArry = newSearchList.filter((v, i, a) => a.findIndex((t1) => t1._id === v._id) === i);
      return {
        ...state,
        BOMLibraryList: action.payload.totalCount ? uniqueArry : [],
        TotalCount: action.payload.totalCount ? action.payload.totalCount : 0,
      };
    }
    case t.GET_BOM_LIBARARY_WITH_SORT: {
      const { doc, pageIndex, totalCount } = action.payload;
      const currentDocs = doc || [];
      const updatedList = pageIndex === 1 ? currentDocs : [...state.BOMLibraryList, ...currentDocs];
      return {
        ...state,
        BOMLibraryList: updatedList,
        TotalCount: totalCount ?? state.TotalCount,
      };
    }
    case t.BOM_LIBARARY_EMPTY:
      return {
        ...state,
        BOMLibraryList: [],
        TotalCount: 0,
      };
    case t.SEARCH_BOM_LIBARARY: {
      const list = action?.payload?.index === 1 ? [] : JSON.parse(JSON.stringify(state.BOMLibraryList));
      const searchList = action?.payload?.data?.doc || [];
      let latestList = searchList?.length ? [...searchList] : [];
      if (list?.length) {
        for (let i = 0; i < list.length; i++) {
          const eleIndex = latestList.findIndex((item) => item._id === list[i]._id);
          if (eleIndex !== -1) list[i] = latestList[eleIndex];
          else latestList.push(list[i]);
        }
      } else {
        latestList = latestList.filter((v, i, a) => a.findIndex((t2) => t2._id === v._id) === i);
      }
      return {
        ...state,
        BOMLibraryList: action?.payload?.data?.totalCount ? latestList : [],
        TotalCount: action?.payload?.data?.totalCount || 0,
      };
    }
    case t.ADD_BOM_LIBARARY_TAGS:
      return {
        ...state,
        TagsInput: action.payload ? action.payload : [],
      };
    case t.GET_BOM_LIBARARY_TAGS:
      return {
        ...state,
        tagsList: action.payload ? action.payload : [],
      };
    case t.GET_BOM_LIBARARYBYID_TAGS:
      return {
        ...state,
        tagsListById: action.payload ? action.payload : [],
      };
    case t.FETCH_SUPPLIER_FACTORIES:
      return {
        ...state,
        supplierFactories: action.payload || [],
      };
    case t.GET_ALL_BOM_OPTIONS:
      return {
        ...state,
        bomOptionsList: action.payload ? action.payload : [],
      };
    case t.CLEAR_DATA:
      return {
        ...state,
        BOMLibraryList: [],
        newBomLibraryList: [],
        TotalCount: 0,
      };
    case t.FETCH_BOM_SUB_COMPONENT_TYPE:
      return {
        ...state,
        bomComponentSubTypeList: action.payload,
      };
    case t.FETCH_BOM_SUB_LIST_COMPONENT_TYPE:
      return {
        ...state,
        bomComponentSubTypeBomList: action.payload,
      };

    default:
      return state;
  }
};

export default BomLibrary;

const sortListAsc = (newList, oldList) => {
  if (newList?.length) {
    updateSortAsc.push(...newList);
    return updateSortAsc;
  }
  updateSortAsc = [];
  return oldList;
};

const sortListDesc = (newList, oldList) => {
  if (newList?.length) {
    updateSortDesc.push(...newList);
    return updateSortDesc;
  }
  updateSortDesc = [];
  return oldList;
};
